/** Trimmed "first last" name. Skips an empty part; returns "" when both are empty. */
export const getPassengerFullName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string =>
  [firstName, lastName]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(" ");
